module.exports = __webpack_public_path__ + "img/Acurite_TH.c27f2b2e.png";